"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMenuContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useMenuContextValues_unstable;
    }
});
function useMenuContextValues_unstable(state) {
    const { checkedValues, hasCheckmarks, hasIcons, inline, isSubmenu, menuPopoverRef, mountNode, onCheckedValueChange, open, openOnContext, openOnHover, persistOnItemClick, setOpen, triggerId, triggerRef } = state;
    // This context is created with "@fluentui/react-context-selector", these is no sense to memoize it
    const menu = {
        checkedValues,
        hasCheckmarks,
        hasIcons,
        inline,
        isSubmenu,
        menuPopoverRef,
        mountNode,
        onCheckedValueChange,
        open,
        openOnContext,
        openOnHover,
        persistOnItemClick,
        setOpen,
        triggerId,
        triggerRef
    };
    return {
        menu
    };
}
